import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename, avatarBaseUrl } from '../../../config';

class CompletedReservationHost extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestLastName: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      padding: '10px',
      textAlign: 'left',
    };

    const buttonStyle = {
      margin: 0,
      fontFamily: 'Proxima Nova',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'bold',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#35BAEF',
      backgroundColor: '#35BAEF',
      color: '#ffffff',
      borderTopWidth: '1px',
    };

    const bookingTitle = {
      paddingBottom: '20px',
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '25px',
      margin: '0',
      padding: '0',
      textAlign: 'center',
    };

    const profilePic = {
      borderRadius: '999px',
      margin: '0',
      padding: '0',
      lineHeight: '150%',
      borderSpacing: '0',
      width: '125px',
    };

    const userName = {
      color: '#565a5c',
      fontSize: '26px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    };

    const subTitle = {
      color: '#565a5c',
      fontSize: '18px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    };

    const bold = {
      fontSize: '18px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    };

    const btnCenter = {
      textAlign: 'center',
    };

    const linkText = {
      color: '#35BAEF',
      fontSize: '18px',
      textDecoration: 'none',
      cursor: 'pointer',
    };

    const space = {
      paddingBottom: '20px',
    };
    const {
      content: { reservationId },
    } = this.props;
    const {
      content: { guestName, guestLastName, guestProfilePic, listTitle, hostPayout },
    } = this.props;
    let messageURL = url + '/review/write/' + reservationId;

    return (
      <Layout>
        <Header color="#159CE9" backgroundColor="#F7F7F7" />
        <div>
          <Table width="100%">
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>
                    Congratulations on a successful rental!
                    <EmptySpace height={10} />
                    Thank you for being part of the Yoodlize community. With Yoodlize, you can do
                    more with less because collectively we own everything!
                    <EmptySpace height={10} />
                    If you haven’t yet, make Yoodlize better by telling us about your experience and
                    leaving a review.
                  </div>
                  <EmptySpace height={10} />
                  <div style={btnCenter}>
                    <a style={buttonStyle} href={messageURL}>
                      Leave a review
                    </a>
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    <span style={bold}>
                      Also help our community grow by sharing your rental experience and have the
                      chance to win $100!{' '}
                    </span>
                    <EmptySpace height={10} />
                    Share your rental story on Facebook, Instagram, Twitter or LinkedIn with the
                    #Yoodlize and tag us. You will be entered to win $100! We choose a winner every
                    100 shares.
                  </div>
                  {!hostPayout && (
                    <div>
                      <EmptySpace height={20} />
                      <div style={bold}>
                        Important! Missing payout information. Please add payout information in your
                        user profile so we can send your payment.
                      </div>
                    </div>
                  )}
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={50} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default CompletedReservationHost;



// WEBPACK FOOTER //
// ./src/core/email/template/CompletedReservationHost.js